import { useState } from "react";
import { useTranslation } from "react-i18next"
import Flag from 'react-flagkit';
import { Form, Input, InputNumber, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { countries } from "countries-list";

import { COUNTRY_DATA } from "constants/globalConstants";
import { validators } from "views/SignUp/validate";
import "./style.scss";

const { Option } = Select;

const FlagAndCountryCodeComponent = ({ country, setCountry, className }) => {

  const { countryAbrev, phone } = country;
  const [countryList, setCountryList] = useState(COUNTRY_DATA);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { t } = useTranslation()
  return (
    <div className={`flag-country-code-container cursor-pointer ${className}`}>
      <Select
        open={isDropdownOpen}
        onDropdownVisibleChange={setIsDropdownOpen}
        className="country-code-select"
        style={{ width: 100 }}
        dropdownMatchSelectWidth={false}
        popupClassName="country-code-dropdown"
        dropdownRender={(menu) => (
          <>
            <div className="flag-search flex items-center relative">
              <SearchOutlined className="flag-search-icon" />
              <input
                className="flag-search-input"
                onChange={({ target: { value } }) => setCountryList(
                  COUNTRY_DATA.filter(country => {
                    // Check for number search witt/out + prefix
                    const checkNumericValue = value.startsWith('+') ? value.substring(1) : value;
                    return (
                      country.name.toLowerCase().includes(value.toLowerCase()) ||
                      country?.phone?.includes(checkNumericValue)
                    )
                  })
                )}
                placeholder={`${t("search_here")}...`}
              />
            </div>
            {menu}
          </>
        )}
        onChange={(value, _option) => {
          setCountry({ ...countries[value], countryAbrev: value })
          setIsDropdownOpen(false)
        }}
        value={countryAbrev}
      >
        {
          countryList.map((country) => {
            const { countryAbrev: countryKey, name, phone: countryExt } = country;
            return (
              <Option
                key={countryKey}
                value={countryKey}
                label={name}
              >
                <div class="flag-container">
                  <Flag country={countryKey} />
                </div>
                <span>{`(+${countryExt})`}</span>
                <span>{name}</span>
              </Option>
            )
          })
        }
      </Select>
      <div
        className="flag-phone-ext flex items-center"
        onMouseDown={(event) => {
          event.preventDefault()
          event.stopPropagation()
          setIsDropdownOpen((isOpen) => !isOpen)
        }}
      >
        <div class="flag-container">
          <Flag country={countryAbrev} />
        </div>
        <span className="ml-10 color-primary">{`+${phone}`}</span>
        <div className="dropdown-arrow">
          <div className="arrow"></div>
        </div>
        {/* <div className="country-code-separator"></div> */}
      </div>
    </div>
  )
};

const PhoneInput = ({
  setValue,
  placeholder,
  country,
  setCountry,
  hasPhoneLogin = true,
  className = "",
  overlayClassName = ""
}) => {
  const { t } = useTranslation()

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const { validatePhone, handleKeyPress } = validators;

  return (
    <div className={`phone-input relative ${className ? className : "mb-10"}`}>
      <FlagAndCountryCodeComponent
        country={country}
        setCountry={setCountry}
        className={overlayClassName}
      />
      <Form.Item
        name="phone"
        rules={[
          {
            required: hasPhoneLogin,
            message: t("login_screen.phone_empty"),
          },
          {
            validator: (_, val) => validatePhone(_, val, country.phone, t),
          },
        ]}
      >
        <Input
          name="phone"
          onKeyPress={handleKeyPress}
          onChange={handleChange}
          placeholder={placeholder ?? t("login_screen.phone_placeholder")}
          autoComplete="off"
        />
      </Form.Item>
    </div>
  )
};

export default PhoneInput;
